<template>
  <div>
    <div>
      <div class="title">
        <div class="title_div"></div>
        <div class="titel_text">待审核</div>
      </div>
      <div v-if="checkData.length === 0">
        <el-empty description="没有内容额"></el-empty>
      </div>
      <div v-else class="itemCar">
        <div
          class="itemCar_item"
          v-for="(item, index) in checkData"
          :key="item.id"
          @click="linkDetail(item.id)"
        >
          <div class="itemCar_item_img">
            <img v-if="item.pic_set" class="img" :src="item.pic_set[0]" />
            <el-empty
              v-else
              class="img"
              :image-size="65"
              description="无图片"
            ></el-empty>
          </div>
          <div class="itemCar_item_test">
            <div>
              <span class="fosi">{{ item.goods_name }}</span
              ><span class="focolor">待审核</span>
            </div>
            <div>
              <span>{{ item.goods_type_name }}</span
              ><span>{{ item.create_time }}</span>
            </div>
            <div>
              <span>{{ item.address }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top:40px;margin-bottom:40px;">
      <div class="title">
        <div class="title_div"></div>
        <div class="titel_text">已发布</div>
      </div>
      <div v-if="publishData.length === 0">
        <el-empty description="没有内容额"></el-empty>
      </div>
      <div v-else class="itemCar">
        <div
          class="itemCar_item"
          v-for="(item, index) in publishData"
          :key="item.id"
          @click="linkDetail(item.id)"
        >
          <div class="itemCar_item_img">
            <img v-if="item.pic_set" class="img" :src="item.pic_set[0]" />
            <el-empty
              v-else
              class="img"
              :image-size="65"
              description="无图片"
            ></el-empty>
          </div>
          <div class="itemCar_item_test">
            <div>
              <span class="fosi">{{ item.goods_name }}</span
              ><span class="focolor" style="color:black">已发布</span>
            </div>
            <div>
              <span>{{ item.goods_type_name }}</span
              ><span>{{ item.create_time }}</span>
            </div>
            <div>
              <span>{{ item.address }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { myIndex } from "@/api/pilotService/lostFound";
import { formatTimeNum } from "@/utils";
export default {
  data() {
    return {
      listQuery: {
        page: 1,
        size: 1000,
      },
      checkData: [],
      publishData: [],
    };
  },
  methods: {
    load() {
      myIndex(this.listQuery)
        .then((res) => {
          if (res.code === 0) {
            res.data.data.forEach((Element) => {
              Element.create_time = formatTimeNum(Element.create_time, "Y-M-D");
            });
            this.checkData = res.data.data.filter((Element) => {
              return Element.status == 1;
            });
            this.publishData = res.data.data.filter((Element) => {
              return Element.status == 3;
            });
          }
        })
        .catch((err) => {
          ;
        });
    },
    linkDetail(id) {
      this.$router.push({
        path: `/pilotService/lostFound/lostFoundDetail?id=${id}`,
      });
    },
  },
};
</script>

<style scoped>
.title {
  margin-left: 2%;
  display: flex;
  align-items: center;
}

.title_div {
  width: 10px;
  height: 18px;
  background-color: #409eff;
  border-radius: 5px;
  margin-right: 10px;
}

.titel_text {
  font-weight: 900;
  font-size: 18px;
}

.itemCar {
  display: flex;
  flex-wrap: wrap;
}

.itemCar_item {
  width: 46%;
  /* height: 190px; */
  display: flex;
  border-radius: 10px;
  margin: 2%;
  margin-bottom: 0.5%;
  overflow: hidden;
  box-shadow: 0px 0px 2.8px rgba(0, 0, 0, 0.027),
    0px 0px 6.7px rgba(0, 0, 0, 0.037), 0px 0px 12.5px rgba(0, 0, 0, 0.044),
    0px 0px 22.3px rgba(0, 0, 0, 0.049), 0px 0px 41.8px rgba(0, 0, 0, 0.056),
    0px 0px 100px rgba(0, 0, 0, 0.07);
  cursor: pointer;
}

.itemCar_item_img {
  width: 100%;
  height: 22vh;
  overflow: hidden;
  flex: 2;
}

.itemCar_item_img > .img {
  height: 100%;
}

.itemCar_item_test {
  flex: 3;
  height: 100%;
  padding: 0 10px 10px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  color: #9295a1;
}

.itemCar_item_test > div {
  display: flex;
  justify-content: space-between;
}
.focolor {
  color: #409eff;
}
.itemCar_item_test > div > span {
  font-size: 14px;
}

.fosi {
  font-weight: 900;
  color: #000;
  font-size: 16px !important;
}
@media only screen and (max-width: 768px) {
  .itemCar_item {
    width: 100%;
  }
  .itemCar_item_img {
    height: 17vh;
  }
  .titel_text {
    font-size: 15px;
  }
  .itemCar_item_test > div > span {
    font-size: 14px;
  }
}
</style>